import { cx } from '@emotion/css';
import {
  type DropdownMenuButtonProps,
  Icon,
  MotifScheme,
} from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import {
  customLocaleDropdownButtonCss,
  dropdownButtonIconCss,
  dropdownButtonIconDownCss,
} from './CustomLocaleDropdown.styles';

/**
 * Custom button for phase 1 of snap.com we can get most of the way there by actually updating
 * motif, but not doing that for phase 1.
 */
export const CustomLocaleDropdownButton: FC<DropdownMenuButtonProps> = ({
  children,
  onClick,
  isExpanded,
  ariaLabel,
}) => (
  <button
    type="button"
    role="combobox"
    className={cx(MotifScheme.DEFAULT, customLocaleDropdownButtonCss)}
    onClick={onClick}
    aria-expanded={isExpanded}
    aria-label={ariaLabel}
  >
    {children}
    <Icon
      size={20}
      className={cx(dropdownButtonIconCss, { [dropdownButtonIconDownCss]: isExpanded })}
      name="arrow"
    />
  </button>
);
